
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:207)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.563 16.564l-2.348 2.346 2.348 2.347-1.565 1.565-2.347-2.348-2.346 2.348-1.564-1.565 2.346-2.347-2.346-2.346L30.305 15l2.346 2.346L34.998 15l1.565 1.564zM26 29.914V24.36H14v5.555c0 .148.063.29.176.393a.626.626 0 00.424.163h10.8c.16 0 .312-.059.424-.163a.536.536 0 00.176-.393zm-12-6.666h12v-2.223a.536.536 0 00-.176-.392.625.625 0 00-.424-.163H14.6a.625.625 0 00-.424.163.536.536 0 00-.176.393v2.222zm7.8 5.555v-1.11h2.4v1.11h-2.4z","fill":"#F20808"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:207","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:207"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:207","result":"shape"}})])])])
          )
        }
      }
    